<template>
  <div id="data-tag-container" @mouseenter="e => mouse = true" @mouseleave="e => mouse = false">
    <input
      ref="comment-input"
      type="text"
      :disabled="disabled"
      :placeholder="placeholder"
      v-model="content"
      @focus="e => focus = true"
      @blur="e => focus = false"
      @keydown.up.prevent.stop="e => moveTagIndex('up')"
      @keydown.down.prevent.stop="e => moveTagIndex('down')"
      @keypress.enter.prevent.stop="e => (data.items || []).length < 1 || onCompelete ? $emit('send', content) : commentTag()"
      @input="e => commentOnInput(true)"
      @change="e => $emit('change', content)"
    >
    <div class="data-tag" :style="tagWidth ? { 'min-width': tagWidth } : {}" v-if="data.items && !onCompelete && display && content && (data.items.length > 0 || emptyMsg)">
      <div class="tag-block">
        <template v-if="data.items.length > 0">
          <div v-if="needInfo && data.info && Object.values(data.info).filter(x => x).length" class="tag-info-container">
            <div class="tag-info-block">
              <span
                v-html="types.map(type => (data.info[type].displayed ? data.info[type].displayed + '/' + data.info[type].total + ' ' + data.info[type].subTitle + 's' : '')).filter(x => x).join(', ').replace(/,(?!.*,)/, ', and') + '.'"
              ></span>
            </div>
          </div>
          <div ref="tag-block" class="tag-group-container" :style="tagHeight ? { 'max-height': tagHeight } : {}">
            <div class="tag-group-block" v-for="(key, index) in types" :key="index">
              <div v-if="Object.keys(filtedDatas).length > 1" class="tag-title">{{ data.info ? data.info[key].title : '' }}</div>
              <div
                class="tag"
                v-for="(tag, tindex) in filtedDatas[key]"
                :key="tindex - -types.slice(0, index).reduce((s, type) => s + (filtedDatas[type] || []).length, 0)"
                :class="{ selected: tagIndex === tindex - -types.slice(0, index).reduce((s, type) => s + (filtedDatas[type] || []).length, 0) }"
                @mousemove="e => tagIndex = tindex - -types.slice(0, index).reduce((s, type) => s + (filtedDatas[type] || []).length, 0)"
                @click="commentTag()"
              >
                <span v-html="(tagDisplay || (tag => tag.name))(tag).replace(new RegExp(content, 'ig'), m => '<span class=\'key\'>' + m + '</span>')"></span>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="tab-empty">{{ emptyMsg }}</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { groupBy } from '../../constants/global/util'

export default {
  props: {
    init: {
      type: String,
      default: () => ''
    },
    data: {
      type: Object,
      default: () => ({})
    },
    tagWidth: {
      type: String,
      default: () => ''
    },
    tagHeight: {
      type: String,
      default: () => ''
    },
    needInfo: {
      type: Boolean,
      default: () => true
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    tagDisplay: {
      type: Function,
      default: () => null
    },
    replace: {
      type: Function,
      default: x => x.name
    },
    placeholder: {
      type: String,
      default: () => ''
    },
    emptyMsg: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      content: '',
      tagIndex: 0,
      onCompelete: false,
      focus: false,
      mouse: false,
      display: false
    }
  },
  computed: {
    filtedDatas () {
      return groupBy(this.data.items, item => item.type || 'default', true)
    },
    types () {
      return Object.keys(this.filtedDatas)
    }
  },
  watch: {
    'init' () {
      if (this.content !== this.init) {
        this.content = this.init
      }
    },
    'focus' () {
      this.display = this.focus || this.mouse
    }
  },
  created () {
    if (this.content !== this.init) {
      this.content = this.init
    }
  },
  methods: {
    commentOnInput (compelete) {
      compelete && (this.onCompelete = false)
      this.tagIndex = 0
      this.$emit('input', this.content)
    },
    moveTagIndex (type) {
      switch (type) {
        case 'up': {
          this.tagIndex = (this.tagIndex - -this.data.items.length - 1) % this.data.items.length
          break
        }
        case 'down': {
          this.tagIndex = (this.tagIndex - -1) % this.data.items.length
          break
        }
        default: {}
      }
      this.$refs['tag-block'].scrollTop = 25.5 * this.tagIndex
    },
    commentTag () {
      const curTag = this.data.items[this.tagIndex]
      this.onCompelete = true
      this.content = this.replace(curTag, this.content)
      this.$emit('tag', curTag)
      this.commentOnInput()
      this.$refs['comment-input'].focus()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
#data-tag-container
  position: relative
  input
    width: 100%
    box-sizing: border-box
    &:hover
      & + .description-tag
        .info-container
          opacity: 1
          top: 58px
    &:focus
      & + .description-tag
        .info-container
          opacity: 0
          top: -9999999999999999px
  .data-tag
    position: absolute
    width: 100%
    top: 36px
    overflow: hidden
    z-index: 5
    .tag-block
      width: 100%
      box-sizing: border-box
      padding: 5px 0
      background: white
      border-radius: 3px
      border: 1px solid #003679
      z-index: 100
      .tag-info-container
        width: 100%
        padding: 0 5px
        margin-bottom: 7px
        box-sizing: border-box
        .tag-info-block
          width: 100%
          padding: 3px 5px
          box-sizing: border-box
          background: #F8FAFA
          border-radius: 3px
          color: #003679
      .tag-group-container
        overflow-y: auto
        max-height: 400px
        .tag-group-block
          & > div
            width: 100%
          &:not(:last-child)
            margin-bottom: 8px
          .tag-title
            color: #003679
            margin-bottom: 7px
            padding: 0 10px
            font-weight: bold
            box-sizing: border-box
          .tag
            padding: 3px 10px
            cursor: pointer
            user-select: none
            box-sizing: border-box
            word-break: break-word
            &.selected
              background: #003679
              color: white
              .key
                color: white
            span
              display: contents
              white-space: pre
            .key
              color: #003679
      .tab-empty
        color: #999999
        font-weight: 300
        padding: 0 10px
</style>



// WEBPACK FOOTER //
// src/components/tool/dataTag.vue